import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  error: null,
  selectedGateway: [],
};

const gatewaysSlice = createSlice({
  name: "gateways",
  initialState,
  reducers: {
    clearGateways: state => {
      state.data = initialState.data;
      state.selectedGateway = initialState.selectedGateway;
    },
    initializeGateway: (state, action) => {
      state.data = action.payload;
    },
    addGateway: (state, action) => {
      state.data.push(action.payload);
    },
    updateGateway: (state, action) => {
      const { id, updates } = action.payload;
      const index = state.data.findIndex(gateway => gateway.id === id);
      if (index !== -1) {
        state.data[index] = { ...state.data[index], ...updates };
      }
    },
    deleteGateway: (state, action) => {
      state.data = state.data.filter(gateway => gateway.id !== action.payload);
    },
    setSelectedGateway: (state, action) => {
      state.selectedGateway = action.payload;
    },
  },
});

export const { initializeGateway, addGateway, updateGateway, deleteGateway, clearGateways, setSelectedGateway } =
  gatewaysSlice.actions;

export default gatewaysSlice.reducer;
